(() => {
  const disposers = new Map();
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  function nodes(scope, selector) { return [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)]; }
  function initBundle(root) {
    if (!root || root.dataset.rcBundleReady) return;
    root.dataset.rcBundleReady = 'true';
    var BID = root.dataset.blockId;
    var CART_MIN = parseInt(root.dataset.cartMin, 10) || 40;
    var CART_MAX = parseInt(root.dataset.cartMax, 10) || 80;
    var BUMP_ID = parseInt(root.dataset.bump, 10) || 0;
    var BUMP_PRICE = 9.9;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.ab2-card'));
    var ctaBtn = root.querySelector('.ab2-cta');
    var ctaText = root.querySelector('.ab2-cta__text');
    var errorEl = root.querySelector('.ab2-error');
    var timerEl = root.querySelector('#ab2-timer-' + BID);
    var counterEl = root.querySelector('#ab2-count-' + BID);
    var reviewEls = root.querySelectorAll('.ab2-review');
    var bumpCb = root.querySelector('.ab2-bump__cb');
    var bumpMsg = root.querySelector('.ab2-bump__msg');

    var selectedVariantId = '';
    var CTA_DEFAULT_TEXT = ctaText ? ctaText.textContent.trim() : 'AGGIUNGI AL CARRELLO';

    var activeCard = root.querySelector('.ab2-card--active');
    if (activeCard) { selectedVariantId = activeCard.dataset.variantId || ''; }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.classList.contains('ab2-radio-input')) { return; }
        selectCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(card); }
      });
      var radio = card.querySelector('.ab2-radio-input');
      if (radio) { radio.addEventListener('change', function () { selectCard(card); }); }
    });

    function selectCard(target) {
      cards.forEach(function (c) {
        c.classList.remove('ab2-card--active');
        c.setAttribute('aria-checked', 'false');
        var r = c.querySelector('.ab2-radio-input');
        if (r) { r.checked = false; }
      });
      target.classList.add('ab2-card--active');
      target.setAttribute('aria-checked', 'true');
      var tr = target.querySelector('.ab2-radio-input');
      if (tr) { tr.checked = true; }
      selectedVariantId = target.dataset.variantId || '';
      hideError();
      updateSavings();
    }

    function updateSavings() { var selected = root.querySelector('.ab2-card--active'); var save = root.querySelector('#mag-save'); if (!selected || !save) return; save.textContent = (root.dataset.thumbs === 'true' ? '👍 ' : '') + root.dataset.savingPrefix + ' ' + (selected.dataset.savings || '0 €') + ' ' + root.dataset.savingSuffix; var days = root.querySelector('.rc-flow-days'); if (days) days.textContent = (selected.dataset.guaranteeDays || Number(selected.dataset.months) * 30) + ' ' + root.dataset.daysLabel; }
    updateSavings();
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        if (!selectedVariantId) { showError(); return; }
        addToCart(selectedVariantId);
      });
    }

    // Single source of truth is snippets/allura-gift-map.liquid. Repeated
    // ids there carry quantity, so collapse them into one line per variant:
    // Shopify does NOT sum duplicate ids inside a single items[] array, it
    // keeps one unit, which is how 3 gel arrived in the cart as 1.
    function giftLinesFor(variantId, groupId) {
      var out = [];
      if (!window.AlluraGiftMap) { return out; }
      var ids = window.AlluraGiftMap.for(variantId);
      var counts = {};
      ids.forEach(function (raw) {
        var id = String(raw).trim();
        if (id === '' || id === 'null') { return; }
        counts[id] = (counts[id] || 0) + 1;
      });
      Object.keys(counts).forEach(function (id) {
        out.push({
          id: parseInt(id, 10),
          quantity: counts[id],
          properties: { '_bundle_parent': groupId }
        });
      });
      return out;
    }

    function postCart(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.json();
      });
    }

    function addToCart(variantId) {
      setLoading(true);
      hideError();
      if (bumpMsg) { bumpMsg.textContent = ''; }

      var groupId = String(Date.now());
      // Gifts first so they sit BELOW the paid item in the cart drawer.
      var items = [];
      items.push({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: { '_bundle_group': groupId }
      });

      // Carry the checked FBT options into this theme's custom bundle cart request.
      var fbtInputs = Array.prototype.slice.call(document.querySelectorAll('[data-fbt-checkbox]:checked'));
      var fbtAddedCount = 0;
      fbtInputs.forEach(function (input) {
        var fbtId = parseInt(input.dataset.variantId, 10);
        if (!fbtId || items.some(function (item) { return parseInt(item.id, 10) === fbtId; })) { return; }
        items.push({ id: fbtId, quantity: 1 });
        fbtAddedCount += 1;
      });

      postCart({ items: items })
        .then(function () {
          trackAddToCart(variantId);
          // Order bump goes in its OWN request, after the kit is safely in
          // the cart. A rejected bump must never cost the sale.
          if (bumpCb && bumpCb.checked && BUMP_ID) {
            return postCart({ items: [{ id: BUMP_ID, quantity: 1 }] })
              .catch(function (err) {
                console.warn('[Allura Bundle] order bump rejected:', err);
                bumpCb.checked = false;
                if (bumpMsg) { bumpMsg.textContent = 'Non e stato possibile aggiungere il gel in piu. Il tuo kit e nel carrello.'; }
              });
          }
          return null;
        })
        .then(function () { return refreshCartDrawer(); })
        .then(function () {
          setLoading(false);
          openDrawer();
          if (fbtAddedCount) { window.dispatchEvent(new CustomEvent('allura:fbt:cart-success')); }
        })
        .catch(function (err) {
          console.error('[Allura Bundle] add to cart failed:', err);
          setLoading(false);
          showError();
          if (fbtAddedCount) { window.dispatchEvent(new CustomEvent('allura:fbt:cart-error')); }
        });
    }

    function trackAddToCart(variantId) {
      if (typeof fbq === 'undefined') { return; }
      try {
        fbq('track', 'AddToCart', {
          content_ids: [String(variantId)],
          content_type: 'product',
          value: getSelectedTilePrice(),
          currency: 'EUR'
        });
      } catch (pixelErr) {
        console.warn('[Allura Bundle] Meta Pixel AddToCart skipped:', pixelErr);
      }
    }

    function getSelectedTilePrice() {
      var active = root.querySelector('.ab2-card--active');
      var priceEl = active && active.querySelector('.ab2-price');
      if (!priceEl) { return 0; }
      var cleaned = priceEl.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
      var val = parseFloat(cleaned) || 0;
      if (bumpCb && bumpCb.checked) { val += BUMP_PRICE; }
      return val;
    }

    function refreshCartDrawer() {
      return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error('Section fetch ' + r.status); } return r.json(); })
        .then(function (data) {
          var freshHtml = data['cart-drawer'];
          if (!freshHtml) { return null; }
          var freshDoc = new DOMParser().parseFromString(freshHtml, 'text/html');
          var liveEl = document.querySelector('cart-drawer');
          var freshEl = freshDoc.querySelector('cart-drawer');
          if (liveEl && freshEl) {
            liveEl.innerHTML = freshEl.innerHTML;
            liveEl.classList.remove('is-empty');
          }
          if (data['cart-icon-bubble']) { var bubble = document.getElementById('cart-icon-bubble'); if (bubble) bubble.innerHTML = data['cart-icon-bubble']; }
          return null;
        });
    }

    function openDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); }
      else { window.location.href = '/cart'; }
    }

    function setLoading(on) {
      if (!ctaBtn) { return; }
      ctaBtn.disabled = on;
      ctaBtn.classList.toggle('ab2-cta--loading', on);
      if (ctaText) { ctaText.textContent = on ? 'Aggiunta in corso...' : CTA_DEFAULT_TEXT; }
    }

    function showError() { if (errorEl) { errorEl.hidden = false; } }
    function hideError() { if (errorEl) { errorEl.hidden = true; } }

    if (timerEl) {
      var tickTimer = function () {
        var now = new Date();
        var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
        var left = midnight.getTime() - now.getTime();
        var h = Math.floor(left / 3600000) % 24;
        var m = Math.floor((left % 3600000) / 60000);
        var s = Math.floor((left % 60000) / 1000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      };
      tickTimer();
      setInterval(tickTimer, 1000);
    }

    if (counterEl) {
      var rnd = function (a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; };
      counterEl.textContent = rnd(CART_MIN, CART_MAX);
      var scheduleDrift = function () {
        setTimeout(function () {
          var cur = parseInt(counterEl.textContent, 10) || CART_MIN;
          var next = Math.min(Math.max(cur + rnd(-3, 3), CART_MIN), CART_MAX);
          counterEl.textContent = next;
          scheduleDrift();
        }, rnd(30000, 90000));
      };
      scheduleDrift();
    }

    if (reviewEls.length > 1) {
      var curR = 0;
      setInterval(function () {
        reviewEls[curR].classList.remove('ab2-review--active');
        curR = (curR + 1) % reviewEls.length;
        reviewEls[curR].classList.add('ab2-review--active');
      }, 4000);
    }

    (function patchStickyATC() {
      var stickyEl = document.querySelector('sticky-atc');
      if (!stickyEl) { return; }
      var ourBtn = document.getElementById('mag-cta');
      if (!ourBtn) { return; }
      stickyEl.style.cssText += ';transition:none!important;transform:translateY(100%)!important;';
      setTimeout(function () { stickyEl.style.transition = 'transform 300ms ease'; }, 200);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var isAboveViewport = entry.boundingClientRect.top < 0;
          stickyEl.style.transform = (!entry.isIntersecting && isAboveViewport) ? 'translateY(0)' : 'translateY(100%)';
        });
      }, { threshold: 0 }).observe(ourBtn);
      var stickyBtn = stickyEl.querySelector('button');
      if (!stickyBtn) { return; }
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (stickyBtn.classList.contains('sticky-atc__scroll-btn')) {
          ourBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          if (!selectedVariantId) { showError(); return; }
          addToCart(selectedVariantId);
        }
      });
    })();

  }
  function initReviews(root) {
    if (!root || root.dataset.rcReviewsReady) return;
    root.dataset.rcReviewsReady = 'true';
  var panel = root.querySelector('.alx-form');
  root.querySelectorAll('[data-alx-toggle]').forEach(function(b){
    b.addEventListener('click', function(){
      panel.classList.toggle('is-open');
      if(panel.classList.contains('is-open')) panel.scrollIntoView({behavior:'smooth', block:'center'});
    });
  });

  var more = root.querySelector('.alx-more button');
  function updateReviewStatus(){
    var all = root.querySelectorAll('.alx-card').length;
    var visible = all - root.querySelectorAll('.alx-card.is-hidden').length;
    if(more && visible === all) more.classList.add('hidden');
  }
  updateReviewStatus();
  if(more){
    more.addEventListener('click', function(){
      var hidden = Array.prototype.slice.call(root.querySelectorAll('.alx-card.is-hidden'));
      hidden.slice(0, Number(root.dataset.loadMore || 6)).forEach(function(c){ c.classList.remove('is-hidden'); });
      if(root.querySelectorAll('.alx-card.is-hidden').length === 0) more.classList.add('hidden');
      updateReviewStatus();
    });
  }

  var photoMarquee = root.querySelector('.alx-marquee');
  var photoPause = root.querySelector('.alx-strip__pause');
  if(photoMarquee && photoPause){
    photoPause.addEventListener('click', function(){
      var paused = photoMarquee.dataset.paused !== 'true';
      photoMarquee.dataset.paused = String(paused);
      photoPause.setAttribute('aria-pressed', String(paused));
      photoPause.setAttribute('aria-label', paused ? 'Riprendi lo scorrimento delle foto' : 'Metti in pausa lo scorrimento delle foto');
      photoPause.textContent = paused ? root.dataset.resumeLabel : root.dataset.pauseLabel;
    });
  }

  root.querySelectorAll('[data-alx-jump]').forEach(function(img){
    img.addEventListener('click', function(){
      var card = document.getElementById('alx-r-' + img.getAttribute('data-alx-jump'));
      if(!card) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('.alx-card'));
      var end = Math.ceil((cards.indexOf(card) + 1) / Number(root.dataset.loadMore || 6)) * Number(root.dataset.loadMore || 6);
      cards.slice(0, end).forEach(function(c){c.classList.remove('is-hidden');});
      updateReviewStatus();
      card.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
    });
  });

  if(window.location.search.indexOf('contact_posted=true') > -1 && panel){
    panel.classList.add('is-open');
    panel.scrollIntoView({behavior:'smooth', block:'center'});
  }

    root.rcRevealReview = blockId => {
      const cards = [...root.querySelectorAll('.alx-card')];
      const index = cards.findIndex(card => card.id === 'alx-r-' + blockId);
      if (index < 0) return;
      const batch = Number(root.dataset.loadMore || 6);
      cards.slice(0, Math.ceil((index + 1) / batch) * batch).forEach(card => card.classList.remove('is-hidden'));
      updateReviewStatus();
      const marquee = root.querySelector('.alx-marquee');
      if (marquee) marquee.dataset.paused = 'true';
    };
  }
  function initGallery(root) {
    if (!root || root.dataset.rcGalleryReady) return;
    root.dataset.rcGalleryReady = 'true';
    const track = root.querySelector('.mgb__gal');
    const buttons = [...root.querySelectorAll('[data-slide]')];
    if (!track) return;
    buttons.forEach(button => button.addEventListener('click', () => {
      const slide = document.getElementById(button.dataset.slide);
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: motion() });
    }));
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.slide === entry.target.id)));
    }), { root: track, threshold: .6 });
    [...track.children].forEach(slide => observer.observe(slide));
    disposers.set(root, () => observer.disconnect());
    root.querySelector('.mgb__rate')?.addEventListener('click', event => {
      const reviews = document.querySelector('[data-alx-reviews]');
      if (reviews) { event.preventDefault(); reviews.scrollIntoView({ behavior: motion(), block: 'start' }); }
    });
  }
  function initTabs(root) {
    if (!root || root.dataset.rcTabsReady) return;
    root.dataset.rcTabsReady = 'true';
    const tabs = [...root.querySelectorAll('[role=tab]')];
    const panels = [...root.querySelectorAll('[role=tabpanel]')];
    const select = (tab, focus) => {
      tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => panel.hidden = panel.id !== tab.getAttribute('aria-controls'));
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = tabs.length - 1;
        else return;
        event.preventDefault(); select(tabs[target], true);
      });
    });
    root.rcSelectPanel = id => { const tab = tabs.find(item => item.getAttribute('aria-controls') === id); if (tab) select(tab, false); };
  }
  function initBalance(root) {
    if (!root || root.dataset.rcLevelsReady) return;
    root.dataset.rcLevelsReady = 'true';
    if (root.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    root.classList.add('rc-balance--ready');
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { root.classList.add('rc-balance--played'); observer.disconnect(); }
    }, { threshold: .3 });
    const pair = root.querySelector('.rc-balance__pair');
    if (pair) observer.observe(pair);
    disposers.set(root, () => observer.disconnect());
  }
  function initTimeline(root) {
    if (!root || root.dataset.rcTimelineReady) return;
    root.dataset.rcTimelineReady = 'true';
    const steps = [...root.querySelectorAll('[data-checkpoint]')];
    if (!steps.length) return;
    let reached = -1, frame = 0;
    const staticTimeline = root.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
    const update = () => {
      frame = 0;
      const trigger = innerHeight * .72;
      const rects = steps.map(step => step.querySelector('.mtl__marker').getBoundingClientRect());
      const centers = rects.map(rect => rect.top + rect.height / 2);
      centers.forEach((center, index) => { if (staticTimeline || center <= trigger) reached = Math.max(reached, index); });
      steps.forEach((step, index) => {
        step.classList.toggle('is-reached', index <= reached);
        if (index === steps.length - 1) return;
        const progress = staticTimeline ? 1 : Math.max(0, Math.min(1, (trigger - centers[index]) / (centers[index + 1] - centers[index])));
        const previous = Number(step.style.getPropertyValue('--step-progress')) || 0;
        step.style.setProperty('--step-progress', Math.max(previous, progress));
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    update();
    disposers.set(root, () => { removeEventListener('scroll', schedule); removeEventListener('resize', schedule); cancelAnimationFrame(frame); });
  }
  function initSticky() {
    const bar = document.querySelector('[data-rc-sticky]');
    if (!bar) return;
    disposers.get(bar)?.();
    const cta = document.getElementById('mag-cta');
    if (!cta || bar.hidden) { bar.classList.remove('on'); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => bar.classList.toggle('on', !entry.isIntersecting && entry.boundingClientRect.top < 0)));
    observer.observe(cta);
    disposers.set(bar, () => observer.disconnect());
    if (!bar.dataset.rcStickyReady) {
      bar.dataset.rcStickyReady = 'true';
      bar.querySelector('button').addEventListener('click', () => document.getElementById('mag-tiers')?.scrollIntoView({ behavior: motion(), block: 'start' }));
    }
  }
  function init(scope) {
    nodes(scope, '[data-rc-buybox]').forEach(initGallery);
    nodes(scope, '[data-rc-bundle]').forEach(initBundle);
    nodes(scope, '[data-alx-reviews]').forEach(initReviews);
    nodes(scope, '[data-rc-tabs]').forEach(initTabs);
    nodes(scope, '[data-rc-balance]').forEach(initBalance);
    nodes(scope, '[data-rc-timeline]').forEach(initTimeline);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of disposers) if (event.target.contains(root)) { dispose(); disposers.delete(root); }
  });
  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail?.blockId;
    const section = document.getElementById('shopify-section-' + event.detail?.sectionId);
    if (!section) return;
    const reviewRoot = section.querySelector('[data-alx-reviews]');
    reviewRoot?.rcRevealReview?.(blockId);
    const panel = event.target.closest('[role=tabpanel]');
    if (panel) panel.closest('[data-rc-tabs]')?.rcSelectPanel?.(panel.id);
    const slide = event.target.closest('[id^=rc-slide-]');
    if (slide) { const track = slide.parentElement; track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant' }); }
  });
})();
